<template>
  <div class="pageDiv">
    <v-card class="" v-if="!$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Config Admin</span>
      </v-card-title>
      Must login to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Load Images Admin</span>
      </v-card-title>

      <div style="margin-top: 20px">
        <div class="flex-container">
          <div>
            <span class="label14" style="margin-right: 12px">Choose Folder: </span>
            <select class="dropdown" v-model="folderName">
              <option value="common">common</option>
              <option value="home">home</option>
              <option value="gallery">gallery</option>
              <option value="sponsors">sponsors</option>
            </select>
            <br><br>
            <span class="label16">Choose an image:</span><br>
            <v-btn class="upload-btn" v-on:click="uploadSponsorImage()"
                   :disabled="(selectedImage === null || selectedImage === '')">
              Upload
            </v-btn>
            <input id="choose-file-id" style="padding:5px 10px" type="file" @change="handleFileUpload( $event )"/>
          </div>
        </div>

        <div class="img-div" style="margin-top: 15px">
          <div class="loader" v-if="isBusy"></div>
          <img class="img-div"
               :src="selectedImage" >
          <br>
          <span class="label14">Selected File:</span> {{ selectedImage }}
        </div>
      </div>

      <v-card-text>
        <div class="fileListDiv">
          <span class="label16">Common</span>

          <ul class="ulNumber">
            <li v-for="(file, index) in commonList" :key="file">
              <a @click="selectedImage=file" :class="{selectedPic: selectedImage===file}">{{ file }}</a>
            </li>
          </ul>
          <br>

          <span class="label16">Home</span>
          <ul class="ulNumber">
            <li v-for="(file, index) in homeList" :key="file">
              <a @click="selectedImage=file" :class="{selectedPic: selectedImage===file}">{{ file }}</a>
            </li>
          </ul>
          <br>
  
          <span class="label16">Gallery</span>
          <ul class="ulNumber">
            <li v-for="(file, index) in galleryList" :key="file">
              <a @click="selectedImage=file" :class="{selectedPic: selectedImage===file}">{{ file }}</a>
            </li>
          </ul>
          <br>

          <span class="label16">Sponsors</span>
          <ul class="ulNumber">
            <li v-for="(file, index) in sponsorList" :key="file">
              <a @click="selectedImage=file" :class="{selectedPic: selectedImage===file}">{{ file }}</a>
            </li>
          </ul>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      isBusy: false,
      commonList: [],
      homeList: [],
      galleryList: [],
      sponsorList: [],
      folderName: 'common',
      selectedImage: '',
      fileName: ''
    }),
    mounted: function() {
        var _this = this;

        _this.$CommandSvc.get(_this, '/admin/images/list/common',
            function (data) {
               _this.commonList = data;
            },
            function (error) {
                console.log('ERROR: ' + error);
            });
        _this.$CommandSvc.get(_this, '/admin/images/list/home',
            function (data) {
               _this.homeList = data;
            },
            function (error) {
                console.log('ERROR: ' + error);
            });
        _this.$CommandSvc.get(_this, '/admin/images/list/gallery_1',
            function (data) {
               _this.galleryList = data;
            },
            function (error) {
                console.log('ERROR: ' + error);
            });
      _this.$CommandSvc.get(_this, '/admin/images/list/sponsors',
          function (data) {
              _this.sponsorList = data;
          },
          function (error) {
              console.log('ERROR: ' + error);
          });            
    },
    methods: {

      handleFileUpload( event ){
        this.file = event.target.files[0];
        this.fileName = this.file.name;
        this.selectedImage='/images/' + this.folderName + '/' + this.fileName;
      },
      uploadSponsorImage() {
        var _this = this;

        _this.isBusy = true;

        let formData = new FormData();
        formData.append('file', this.file);

        this.axios.post('/admin/images/upload/' + _this.folderName + '/' + _this.fileName,
          formData,
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function() {
          _this.isBusy = false;
          document.getElementById("choose-file-id").value = "";
          swal("Success", "Image uploaded successfully.", "info")
           .then((willDelete) => {
              window.location.reload();
           });
          console.log('SUCCESS!!');
        })
        .catch(function(error){
          _this.isBusy = false;
          swal("Problem", "Unable to load image.", "error");
          console.log('FAILURE!! ' + error);
        });
      }
    }
  }

</script>

<style scoped>
   .fileListDiv {
      display: inline-block;
      width: 100%;
      height: 580px;
      border: 1px solid black;
      border-radius: 12px;
      padding: 15px;
      overflow-y: scroll;
   }

   .selectedPic {
      color: darkblue;
      font-weight: bold;
   }

   .img-div {
      display: inline-block;
      width: 100%;
    }

    @media (min-width: 768px) {
      .img-div {
        width: 400px !important;
      }
    }

</style>